{
  "access_denied_description": "Contact administrators for more information",
  "access_denied_logout_btn": "Log Out",
  "access_denied_operator_label": "Operator",
  "access_denied_title": "No access to Shop resources",
  "bet_builder": "Bet Builder",
  "bet_details_header_event": "Event",
  "bet_details_header_market": "Market",
  "bet_details_header_odds": "Odds",
  "bet_details_header_outcome": "Outcome",
  "bet_details_header_status": "Status",
  "bet_details_header_time": "Time",
  "bet_details_payment": "Payment",
  "bet_details_payment_tax": "Payment tax",
  "bet_details_possible_payout": "Possible Payout",
  "bet_details_possible_winnings": "Possible winnings",
  "bet_details_stake": "Stake",
  "bet_details_tax_on_winnings": "Tax on winnings",
  "bet_type_combo": "Combo",
  "bet_type_multibet": "Multi-Bet ({ amount })",
  "bet_type_single": "Single",
  "bet_type_system": "System",
  "betslip_action_accepted": "Success",
  "betslip_action_failed": "Failed",
  "betslip_action_pending": "Pending",
  "betslip_action_rejected": "Rejected",
  "betslip_payin": "Betslip Payin",
  "betslip_table_action": "Action",
  "betslip_table_amount": "Amount",
  "betslip_table_game": "Game",
  "betslip_table_id": "ID",
  "betslip_table_status": "Status",
  "betslip_table_time": "Time",
  "cash_register_balance_heading": "BALANCE ({currency})",
  "cash_register_end_session_cash_to_leave_in_register": "Cash to leave in Cash register",
  "cash_register_end_session_cash_transfer": "Cash transfer",
  "cash_register_end_session_confirm": "End Session",
  "cash_register_end_session_confirm_modal_back": "Back",
  "cash_register_end_session_confirm_modal_message": "Are you sure you want to end current session?",
  "cash_register_end_session_confirm_modal_title": "Warning",
  "cash_register_end_session_current_physical_cash_balance": "Current physical cash balance",
  "cash_register_end_session_keep_all_cash_in_register_heading": "Balance ({currency})",
  "cash_register_end_session_keep_all_cash_in_register_option_label": "Keep all cash in register",
  "cash_register_end_session_keep_all_cash_in_register_title": "BALANCE",
  "cash_register_end_session_note": "Note",
  "cash_register_end_session_register_balance": "Register balance",
  "cash_register_end_session_take_out_amount": "Take out amount",
  "cash_register_end_session_title": "End Session",
  "cash_register_end_session_transfer_type": "Transfer type",
  "cash_register_end_session_transfer_type_bank": "Bank",
  "cash_register_end_session_transfer_type_cash": "Cash",
  "cash_register_make_transfer_amount_label": "Amount",
  "cash_register_make_transfer_direction_label": "Transfer Direction",
  "cash_register_make_transfer_direction_take_in": "Take In",
  "cash_register_make_transfer_direction_take_out": "Take Out (Cash Drop)",
  "cash_register_make_transfer_note_label": "Note",
  "cash_register_make_transfer_note_placeholder": "Take a note...",
  "cash_register_make_transfer_submit_button": "Transfer",
  "cash_register_make_transfer_title": "Make Transfer",
  "cash_register_make_transfer_type_label": "Transfer type",
  "cash_register_no_session_description": "Start new session to activate cash register",
  "cash_register_no_session_title": "No active session",
  "cash_register_session_details_balance": "Balance",
  "cash_register_session_details_closed_at": "Closed at",
  "cash_register_session_details_closed_by": "Closed by",
  "cash_register_session_details_duration": "Duration",
  "cash_register_session_details_end_session_button": "End Session",
  "cash_register_session_details_id": "Session ID",
  "cash_register_session_details_info_title": "Session info",
  "cash_register_session_details_make_transfer_button": "Make Transfer",
  "cash_register_session_details_opened_at": "Opened at",
  "cash_register_session_details_opened_by": "Opened by",
  "cash_register_session_details_operators": "Operators",
  "cash_register_session_details_opt_in_button": "Opt In",
  "cash_register_session_details_opted_in_button": "Opted In",
  "cash_register_session_details_title": "Sessions",
  "cash_register_session_details_transactions": "Transactions",
  "cash_register_session_details_transactions_credit_debit_card_balance": "Credit/debit card balance ({currency})",
  "cash_register_session_details_transactions_direct_deposits": "Direct deposits",
  "cash_register_session_details_transactions_physical_cash": "Physical cash ({currency})",
  "cash_register_session_details_transactions_retail_location_withdrawals": "Retail location withdrawals",
  "cash_register_session_details_transactions_starting_cash_balance_cash_float": "Starting cash balance (cash float)",
  "cash_register_session_details_transactions_title": "Session transactions",
  "cash_register_session_details_transactions_total_balance": "Total balance ({currency})",
  "cash_register_session_details_transactions_voucher_issued": "Issued",
  "cash_register_session_details_transactions_voucher_redeemed": "Redeemed",
  "cash_register_session_details_transactions_voucher_revoked": "Revoked",
  "cash_register_session_operators_popup_description": "List of operators included in this session",
  "cash_register_session_opt_in_failed": "Opting in to session failed!",
  "cash_register_start_session_failed": "Session start failed!",
  "cash_register_start_session_info_notification": "Starting cash balance is determined by the previously closed session. You may always correct the cash float with “Make transfer” action.",
  "cash_register_start_session_success": "New session started!",
  "cash_register_start_session_title": "Start Session",
  "cash_register_starting_cash_balance": "Starting cash balance",
  "common_all_info": "All info",
  "common_app_version": "Application version",
  "common_back": "Back to",
  "common_betshop": "Betshop",
  "common_cancel": "Cancel",
  "common_cash_register": "Cash Register",
  "common_company": "Company",
  "common_copy_all_info": "Copy all info",
  "common_currency": "Currency",
  "common_deposits": "Deposits",
  "common_device": "Device",
  "common_device_uuid": "Device UUID",
  "common_direct_transfer": "Direct Transfer",
  "common_error": "An unknown error has occurred. Please try again",
  "common_games": "Games",
  "common_info": "Information",
  "common_language": "Language",
  "common_load_more": "Load more",
  "common_logout": "Log Out",
  "common_menu": "Menu",
  "common_operations": "Operations",
  "common_payin": "Payin",
  "common_payout": "Payout",
  "common_plugins": "Plugins",
  "common_print": "Print",
  "common_products": "Products",
  "common_rebet": "Rebet",
  "common_save": "Save",
  "common_services": "Services",
  "common_settings": "Settings",
  "common_start_session": "Start Session",
  "common_transfers": "Transfers",
  "common_unknown": "Unknown",
  "common_voucher": "Voucher",
  "common_vouchers": "Vouchers",
  "deposits_direct_deposit_create_error": "Creating deposit failed!",
  "deposits_direct_deposit_create_success": "{amount}{currency} deposited to player \"{playerNickname}\"",
  "deposits_direct_deposit_form_max_amount_validation_error": "Max amount is {amount}",
  "deposits_direct_deposit_form_min_amount_validation_error": "Min amount is {amount}",
  "deposits_direct_deposit_form_player_label": "Player's Email or Nickname",
  "deposits_direct_deposit_form_player_not_found": "Player not found",
  "deposits_direct_deposit_form_submit_button": "Next",
  "deposits_direct_deposit_method_card": "Card",
  "deposits_direct_deposit_method_cash": "Cash",
  "deposits_direct_deposit_player_side_sheet_email": "Email",
  "deposits_direct_deposit_player_side_sheet_full_name": "Full Name",
  "deposits_direct_deposit_player_side_sheet_nickname": "Nickname",
  "deposits_direct_deposit_player_side_sheet_verification_status": "Verification Status",
  "deposits_direct_deposit_print_failed": "Confirmation slip failed to be printed due to printer error.",
  "deposits_direct_deposit_side_sheet_amount_label": "Deposit Amount",
  "deposits_direct_deposit_side_sheet_confirm_button": "Confirm Deposit",
  "deposits_direct_deposit_side_sheet_method_label": "Deposit Method",
  "deposits_direct_deposit_side_sheet_title": "Direct Deposit",
  "deposits_direct_deposit_verification_status_fully_verified": "Fully Verified",
  "deposits_direct_deposit_verification_status_not_verified": "Not Verified",
  "deposits_direct_deposit_verification_status_partially_verified": "Partially Verified",
  "deposits_direct_deposits_no_session_notification": "To make a deposit you have to start the session.",
  "deposits_direct_table_empty_description": "No deposits in the past {timePeriod}.",
  "deposits_direct_table_empty_title": "No deposits",
  "deposits_direct_table_header_amount": "Amount",
  "deposits_direct_table_header_id": "Deposit ID",
  "deposits_direct_table_header_made_at": "Created",
  "deposits_direct_table_time_period_label": "Time period",
  "deposits_direct_table_title": "Last deposits",
  "deposits_direct_transfer_subtitle": "Create a deposit and credit funds directly to a player's account. Deposits made by you are listed below.",
  "deposits_direct_transfer_title": "Make Direct Deposit",
  "deposits_voucher_create_error": "Creating voucher failed!",
  "deposits_voucher_create_success": "Voucher created.",
  "deposits_voucher_form_amount_label": "Amount",
  "deposits_voucher_form_create_button": "Create",
  "deposits_voucher_form_max_amount_validation_error": "Max amount is {amount}",
  "deposits_voucher_form_min_amount_validation_error": "Min amount is {amount}",
  "deposits_vouchers_subtitle": "Create a voucher that players can use as a payment method. Vouchers created by you are listed below.",
  "deposits_vouchers_table_empty_description": "No created vouchers in the past {timePeriod}.",
  "deposits_vouchers_table_empty_title": "No vouchers",
  "deposits_vouchers_table_header_created": "Created",
  "deposits_vouchers_table_header_source": "Source",
  "deposits_vouchers_table_header_status": "Status",
  "deposits_vouchers_table_header_value": "Value",
  "deposits_vouchers_table_header_voucher_id": "Voucher ID",
  "deposits_vouchers_table_time_period_label": "Time period",
  "deposits_vouchers_title": "Create Voucher",
  "info_tab_main_info": "Main Info",
  "info_tab_working_time": "Working Time",
  "info_working_time_open": "Open",
  "info_working_time_closed": "Closed",
  "info_copy_to_clipboard_success": "{ title } copied to clipboard.",
  "keyboard_shortcuts_not_found": "No enabled shortcuts for this category!",
  "login_operator_account_disabled_error_message": "Access denied. Account is currently disabled.",
  "login_operator_credentials_error_message": "Invalid operator credentials",
  "login_operator_device_not_connected_error_message": "Access denied. Device is not connected.",
  "login_operator_max_concurrent_sessions_error_message": "Access denied. You've reached the maximum number of concurrent device sessions. Log out from another device and try again.",
  "login_operator_default_button_text": "Login",
  "login_operator_pass_label": "Password",
  "login_operator_remember_username": "Remember username",
  "login_operator_title": "Operator Login",
  "login_operator_unauthorized_location_error_message": "Access denied. You are not authorized to log in from this location.",
  "login_operator_user_label": "Username",
  "operator_logout": "You are logged out.",
  "operation_navigation_cash_register": "Cash Register",
  "operation_navigation_deposits": "Deposits",
  "operation_navigation_keyboard_shortcuts": "Keyboard Shortcuts",
  "operation_navigation_reports": "Reports",
  "operation_navigation_settings": "Settings",
  "operation_navigation_withdrawal": "Withdrawal",
  "printer_action_perform_print_failed": "Printer action failed. Please try again.",
  "printer_action_perform_print_success": "Successfully printed",
  "printer_action_refresh_success": "PoS Printer list refreshed",
  "printer_autocutter": "Autocutter",
  "printer_cover_open": "Printer cover is open",
  "printer_offline": "Printer is offline, check paper and printer lid",
  "printer_paper_error_notification": "No more paper in printer. Please call your operator.",
  "printer_paper_low": "Paper low",
  "printer_paper_out": "Paper out",
  "printer_paper_out_while_printing": "Paper out while printing",
  "settings_interface_language": "Interface language",
  "settings_last_tickets": "Latest Betslips",
  "settings_last_tickets_current_game": "Current Game",
  "settings_last_tickets_games": "Show betslips from games",
  "settings_last_tickets_games_placeholder": "Select Games",
  "settings_last_tickets_number": "Number of betslips to show",
  "settings_last_tickets_number_placeholder": "Select Amount",
  "settings_last_tickets_show_all": "Show All",
  "settings_modal_discard_changes": "Discard",
  "settings_modal_unsaved_changes_message": "You have unsaved changes. By leaving this tab you will discard them?",
  "settings_modal_unsaved_changes_title": "Warning",
  "settings_print_a4_configuration": "A4 Printer Configuration",
  "settings_print_a4_configuration_description": "Paper format A4",
  "settings_print_a4_test": "Test print for A4 Printer",
  "settings_print_a4__test_modal_title": "Print Test",
  "settings_print_a4_title": "A4 Printer",
  "settings_print_configure": "Configure",
  "settings_print_pos_configuration": "PoS Printer Configuration",
  "settings_print_pos_configuration_description": "Configuration for print output layout",
  "settings_print_pos_configuration_label": "Select Configuration",
  "settings_print_pos_printer": "PoS printer",
  "settings_print_pos_printer_label": "Select PoS printer",
  "settings_print_pos_test": "Test print for PoS Printer",
  "settings_print_pos_title": "PoS Printer",
  "settings_print_test": "Print test",
  "settings_printing_language": "Printing language",
  "settings_save_success": "Changes saved",
  "slip_action_check": "Check",
  "slip_action_print_copy": "Print Copy",
  "slip_action_rebet": "Rebet",
  "slip_cancel_ticket": "Cancel Ticket",
  "slip_cancel_ticket_failed": "Cancel ticket failed",
  "slip_check_details_bet_title": "Bet {index}: {title}",
  "slip_check_details_betslip_id": "Betslip ID",
  "slip_check_error": "Failed to check betslip.",
  "slip_check_modal_check_button": "Check",
  "slip_check_modal_content": "Enter a ticket ID or scan the barcode to view ticket details.",
  "slip_check_modal_ticket_id_label": "Ticket ID",
  "slip_check_modal_title": "Ticket Check",
  "slip_payin": "Betslip Payin",
  "slip_payin_success": "Ticket has been successfully paid in.",
  "slip_payout_betslip": "Payout Betslip: {amount} {currency}",
  "slip_payout_failed": "Payout failed",
  "slip_pending_action": "Please wait for slip confirmation.",
  "slip_print_copy": "Print Copy",
  "slip_print_copy_failed": "Print copy failed",
  "slip_print_failed": "Failed to print slip",
  "slip_print_payout_confirmation": "Print Payout Confirmation",
  "slip_print_payout_confirmation_failed": "Print payout confirmation failed",
  "slip_rebet_failed": "Rebet failed",
  "slip_resolve_failed": "Failed to resolve slip",
  "slip_status_accepted": "Success",
  "slip_status_failed": "Failed",
  "slip_status_pending": "Pending",
  "slip_status_rejected": "Rejected",
  "slip_table_action": "Action",
  "slip_table_amount": "Amount",
  "slip_table_game": "Game",
  "slip_table_id": "ID",
  "slip_table_status": "Status",
  "slip_table_time": "Time",
  "time_period_last_24_hours": "Last 24 hours",
  "time_period_last_hour": "Last hour",
  "voucher_details_footer_redeem": "Redeem Voucher",
  "voucher_details_footer_revoke": "Revoke Voucher",
  "voucher_details_header_amount": "Amount",
  "voucher_details_header_issued_in": "Issued in",
  "voucher_details_header_redeemed_at": "Redeemed at",
  "voucher_details_header_redeemed_in": "Redeemed in",
  "voucher_details_header_status_expired": "Expired",
  "voucher_details_header_status_redeemed": "Redeemed",
  "voucher_details_header_status_revoked": "Revoked",
  "voucher_details_header_status_valid": "Valid: {date}",
  "voucher_details_header_valid_until": "Valid Until",
  "voucher_print_failed": "Failed to send voucher to print.",
  "voucher_print_success": "Voucher has been printed successfully.",
  "voucher_redeem_failed": "Failed to redeem voucher.",
  "voucher_revoke_failed": "Failed to revoke voucher.",
  "voucher_revoke_success": "Voucher has been revoked successfully.",
  "widget_latest_betslips": "Latest Betslips",
  "widget_shortcuts_title": "Shortcuts",
  "widget_shortcuts_all_shortcuts": "All Shortcuts",
  "widget_calculator": "Calculator",
  "calculator_transactions_title": "Transactions",
  "calculator_session_tab": "Session {currency}",
  "calculator_table_title": "Table ({count})",
  "calculator_no_transactions": "No recorded transactions in the current calculator session.",
  "calculator_money_in": "Money In",
  "calculator_money_in_modal_title": "Money In",
  "calculator_payments": "Payments",
  "calculator_payouts": "Payouts",
  "calculator_rest": "Rest",
  "calculator_give_to_player": "Return to player",
  "calculator_collect_from_player": "Collect from player",
  "calculator_reset_session": "Reset Session",
  "calculator_clear_session_currency": "Clear {currency}",
  "calculator_pin_view": "Pin calculator",
  "calculator_full_screen": "Expanded view",
  "calculator_helper_tip": "Whenever you hand out cash to the player, clear the calculator or exclude that transaction from the log to avoid mistakes.",
  "calculator_reset_session_title": "Reset session",
  "calculator_reset_session_message": "Are you sure you want to reset current session?",
  "calculator_reset_session_confirm": "Reset",
  "calculator_close": "Close",
  "calculator_excluded_transactions_warning": "You have manually excluded {excluded}/{total} transactions",
  "calculator_table_include": "Include",
  "calculator_table_item": "Item",
  "calculator_table_id": "ID",
  "calculator_table_time": "Time",
  "calculator_table_action": "Action",
  "calculator_table_amount": "Amount (+/-)",
  "calculator_table_status": "Status",
  "calculator_action_betslip_payin": "Betslip Payin",
  "calculator_action_betslip_payout": "Betslip Payout",
  "calculator_action_betslip_cancel": "Betslip Cancel",
  "calculator_action_betslip_cashout": "Betslip Cashout",
  "calculator_action_voucher_create": "Voucher Create",
  "calculator_action_voucher_redeem": "Voucher Redeem",
  "calculator_action_voucher_revoke": "Voucher Revoke",
  "calculator_action_bet_payout": "Bet Payout",
  "calculator_action_bet_cashout": "Bet Cashout",
  "calculator_action_bet_cancel": "Bet Cancel",
  "calculator_action_direct_deposit": "Direct Deposit",
  "calculator_action_retail_location_withdrawal": "Retail Location Withdrawal",
  "calculator_status_pending": "Pending",
  "calculator_status_success": "Success",
  "calculator_status_fail": "Fail",
  "calculator_status_reject": "Reject",
  "working_hours_off": "Location working hours are currently off. Next opening: {datetime}."
}
